<div class="m-3">
    <button type="button" (click)="close()" class="close d-flex justify-content-end">
        <i class="modus-icons">close</i>
    </button>
    <h2 class="font-weight-bold text-primary">Choose company for onboarding:</h2>
</div>
<button *ngFor="let company of companies" (click)="itemClicked(company.PRCo)" class="list-group-item list-group-item-action">
    {{company.PRCoNameMask}}
</button>
